import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", null, "帳票項目設定", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditDialog())),
        disabled: _ctx.loading,
        color: "primary",
        depressed: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { left: "" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" 新規作成 ", -1))
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.itemResponse ? _ctx.itemResponse.data : [],
        loading: _ctx.loading,
        "hide-default-footer": "",
        "items-per-page": -1
      }, {
        [`item.type`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.getCategryText(item.type)), 1)
        ]),
        [`item.createdAt`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
        ]),
        [`item.edit`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.openEditDialog(item)),
            disabled: _ctx.loading,
            color: "primary",
            variant: "outlined",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode(" 編集 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        [`item.delete`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.deleteFormItem(item.id)),
            disabled: _ctx.loading,
            color: "error",
            size: "small",
            depressed: ""
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" 削除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 2
      }, 1032, ["headers", "items", "loading"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("帳票項目", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode(" 項目名称* ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.input.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.name) = $event)),
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode(" 項目種類* ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.input.type,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.type) = $event)),
                              items: _ctx.categoryItems,
                              "item-title": "text",
                              "item-value": "value",
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.input.type == 'childText')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" クラス ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.input.classIdList,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.classIdList) = $event)),
                                  items: _ctx.classes,
                                  "item-text": "className",
                                  "item-value": "classId",
                                  multiple: "",
                                  chips: "",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "items"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.input.type == 'grid')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode(" 行（縦に並ぶ項目） ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.headerInput.rows,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.headerInput.rows) = $event)),
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  label: "カンマ区切り",
                                  placeholder: "例) 項目1,項目2,..."
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.input.type == 'grid')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 2,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                _createTextVNode(" 列（横に並ぶ項目） ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.headerInput.cols,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.headerInput.cols) = $event)),
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  label: "カンマ区切り",
                                  placeholder: "例) 項目1,項目2,..."
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        (_ctx.isUpdate)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _ctx.updateFormItem,
                              disabled: _ctx.loading,
                              color: "primary",
                              depressed: ""
                            }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode(" 保存 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "disabled"]))
                          : (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              onClick: _ctx.createFormItem,
                              disabled: _ctx.loading,
                              color: "primary",
                              depressed: ""
                            }, {
                              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                _createTextVNode(" 作成 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}